import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=8ca8c9f8"
import script from "./js/statistics.js?vue&type=script&lang=js&external"
export * from "./js/statistics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports